module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-progress-bar"
  }, [_c('div', {
    staticClass: "rt-progress__outer"
  }, [_c('div', {
    staticClass: "rt-progres__inner",
    style: (_vm.computedWidth)
  })]), _vm._v(" "), _c('div', {
    staticClass: "rt-progress-text"
  }, [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e67a9f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/progress/rtProgress.vue
// module id = 1507
// module chunks = 72